// Müşteri servisi - Müşteri API çağrıları
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Müşteri servis fonksiyonları
export const customerService = {
  // Müşteri listesini al
  async getCustomers(params = {}) {
    try {
      const response = await api.get('/customers', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri detaylarını al
  async getCustomer(id) {
    try {
      const response = await api.get(`/customers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Yeni müşteri oluştur
  async createCustomer(customerData) {
    try {
      const response = await api.post('/customers', customerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri güncelle
  async updateCustomer(id, customerData) {
    try {
      const response = await api.put(`/customers/${id}`, customerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri sil
  async deleteCustomer(id) {
    try {
      const response = await api.delete(`/customers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri kontağı ekle
  async addContact(customerId, contactData) {
    try {
      const response = await api.post(`/customers/${customerId}/contacts`, contactData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri kontağı güncelle
  async updateContact(customerId, contactId, contactData) {
    try {
      const response = await api.put(`/customers/${customerId}/contacts/${contactId}`, contactData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri kontağı sil
  async deleteContact(customerId, contactId) {
    try {
      const response = await api.delete(`/customers/${customerId}/contacts/${contactId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri kontağı notu güncelle
  async updateContactNote(customerId, contactId, note) {
    try {
      const response = await api.put(`/customers/${customerId}/contacts/${contactId}/note`, { note });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri toplantıları
  async getCustomerMeetings(customerId) {
    try {
      const response = await api.get(`/customers/${customerId}/meetings`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async addCustomerMeeting(customerId, meetingData) {
    try {
      const response = await api.post(`/customers/${customerId}/meetings`, meetingData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCustomerMeeting(meetingId, meetingData) {
    try {
      const response = await api.put(`/customers/meetings/${meetingId}`, meetingData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCustomerMeetingStatus(meetingId, statusData) {
    try {
      const response = await api.put(`/customers/meetings/${meetingId}/status`, statusData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCustomerMeeting(meetingId) {
    try {
      const response = await api.delete(`/customers/meetings/${meetingId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri notları
  async getCustomerNotes(customerId) {
    try {
      const response = await api.get(`/customers/${customerId}/notes`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async addCustomerNote(customerId, noteData) {
    try {
      const response = await api.post(`/customers/${customerId}/notes`, noteData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCustomerNote(noteId, noteData) {
    try {
      const response = await api.put(`/customers/notes/${noteId}`, noteData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCustomerNote(noteId) {
    try {
      const response = await api.delete(`/customers/notes/${noteId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri teklifleri
  async getCustomerOffers(customerId) {
    try {
      const response = await api.get(`/customers/${customerId}/offers`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCustomerOffer(customerId, formData) {
    try {
      const response = await api.post(`/customers/${customerId}/offers`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCustomerOffer(offerId, formData) {
    try {
      const response = await api.put(`/customers/offers/${offerId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCustomerOfferStatus(offerId, status) {
    try {
      const response = await api.put(`/customers/offers/${offerId}/status`, { offer_status: status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCustomerOffer(offerId) {
    try {
      const response = await api.delete(`/customers/offers/${offerId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCustomerOfferFile(offerId) {
    try {
      const response = await api.delete(`/customers/offers/${offerId}/file`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async downloadCustomerOfferFile(offerId) {
    try {
      const response = await api.get(`/customers/offers/${offerId}/download`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
};
